/**
 * Footer Stateless Component
 */
import { ToggleLanguage } from "components/UI/Toggle/ToggleLanguage";
import * as React from "react";
import { Translate } from "react-localize-redux";
import { Col, Row } from "reactstrap";
import { HrefEnum } from "root/shared/HrefEnum";
import { PciImages } from "root/shared/PciImages";
import "./assets/css/styles.css";

const Footer: React.StatelessComponent<{
  // tslint:disable: max-union-size
  pciClass?: PciImages;
  showLanguajeToggle?: boolean;
  showCardDocumentation?: boolean;
  showPseDocumentation?: boolean;
}> = (props: {
  pciClass?: string;
  showLanguajeToggle?: boolean;
  showCardDocumentation?: boolean;
  showPseDocumentation?: boolean;
}): React.ReactElement<{ pciClass?: string }> => (
  <>
    {Boolean(props.pciClass) ? <div className={props.pciClass} /> : null}
    <div className="powered-container">
      <span className="powered-title">Powered by</span>
      <img
        src="/assets/images/logo_ksh.png"
        width={67}
        height={16}
        alt="kushki-logo"
      />
    </div>
    <div className="d-flex justify-content-center align-items-center mt-2">
      <img
        src="/assets/images/pci_logo.png"
        width={50}
        height={20}
        alt="kushki-logo"
      />
      <div className="card-type-warning ml-2">
        <Translate id="footer.secureMessage" />
      </div>
    </div>
    {Boolean(props.showCardDocumentation) ? (
      <Row>
        <Col xs="12" sm="12" lg="12">
          <div className="d-flex justify-content-center align-items-center mt-2">
            <div className="card-documentation ml-2">
              <a
                href={HrefEnum.CARD_DOCUMENTATION}
                target="_blank"
                rel="noopener noreferrer"
                className="link-color"
              >
                <Translate id="footer.cardDocumentation" />
              </a>
            </div>
          </div>
        </Col>
      </Row>
    ) : null}
    {Boolean(props.showPseDocumentation) ? (
      <Row>
        <Col xs="12" sm="12" lg="12">
          <div className="d-flex justify-content-center align-items-center mt-2">
            <div className="pse-documentation ml-2">
              <a
                href={HrefEnum.PSE_DOCUMENTATION}
                target="_blank"
                rel="noopener noreferrer"
                className="link-color"
              >
                <Translate id="footer.pseDocumentation" />
              </a>
            </div>
          </div>
        </Col>
      </Row>
    ) : null}
    <Row>
      <Col xs="12" sm="12" lg="12">
        {props.showLanguajeToggle === false ? null : <ToggleLanguage />}
      </Col>
    </Row>
  </>
);

export { Footer };



// WEBPACK FOOTER //
// ./src/components/UI/Footer/FooterComponent.tsx